<template>
  <div class="login-header d-flex justify-content-center align-items-center p-2 w-100">
    <div class="header-title flex-grow-1 text-center">
      ADMIN DASHBOARD
    </div>
    <div class="dropdown">
      <button
        class="btn btn-primary dropdown-toggle d-flex align-items-center"
        type="button"
        id="dropdownMenuButton"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <div class="profile-photo">
          <img :src="profilePhotoUrl" alt="Profile Photo" />
        </div>
        <span class="ms-2">{{ firstName }}</span>
      </button>
      <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <li>
          <a class="dropdown-item" href="#" @click="logout">Logout</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginHeader",
  data() {
    return {
      firstName: localStorage.getItem("first_name") || "John",
      profilePhoto: localStorage.getItem("profile_photo_url"), // Get from localStorage
    };
  },
  computed: {
    profilePhotoUrl() {
      return this.profilePhoto && this.profilePhoto !== "null"
        ? this.profilePhoto
        : require("@/assets/ProfileSample/Profile Pictures B.png"); // Use default image
    },
  },
  methods: {
    logout() {
      localStorage.clear();
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
.header-title {
  flex: 1;
  text-align: center;
}

.profile-photo {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.profile-photo img {
  width: 100%;
  height: auto;
  border-radius: 50%;
}

/* Media Queries for responsiveness */
@media (max-width: 769px) {
  .login-header .btn {
    padding: 0.25rem 0.5rem;
  }
  .profile-photo {
    width: 25px;
    height: 25px;
  }
  .btn span {
    font-size: 0.875rem; /* Adjust font size for smaller screens */
  }
}

@media (max-width: 500px) {
  .login-header .btn {
    padding: 0.2rem 0.4rem;
  }
  .profile-photo {
    width: 20px;
    height: 20px;
  }
  .btn span {
    font-size: 0.75rem; /* Adjust font size for even smaller screens */
  }
}
</style>
